import { Injectable } from '@angular/core';
import {
  FormTemplateApi,
  FormTemplateTypes,
  FormTemplateUsage,
  Page,
} from '@models';
import { delay, filter, map, Observable, of } from 'rxjs';
import { FormTemplatesService } from './form-templates.interface';
import { MOCK_DATA_CONENT_FORM_TEMPLATE } from '@services';

const MOCK_DATA: FormTemplateApi[] = [
  ...MOCK_DATA_CONENT_FORM_TEMPLATE,
  {
    id: '2',
    name: 'Version 1',
    version: 1,
    type: FormTemplateTypes.IntakeForm,
    lastUpdatedUtc: new Date().toISOString(),
    appointmentType: '',
  },
  {
    id: '3',
    name: 'Version 2',
    version: 2,
    type: FormTemplateTypes.IntakeForm,
    lastUpdatedUtc: new Date().toISOString(),
    appointmentType: '',
  },
  {
    id: '4',
    name: 'Version 3',
    version: 3,
    type: FormTemplateTypes.IntakeForm,
    lastUpdatedUtc: new Date().toISOString(),
    appointmentType: '',
  },
  {
    id: '5',
    name: 'Version 4',
    version: 4,
    type: FormTemplateTypes.IntakeForm,
    lastUpdatedUtc: new Date().toISOString(),
    appointmentType: '',
  },
];

@Injectable({
  providedIn: 'root',
})
export class FormTemplatesMockService implements FormTemplatesService {
  params = {
    page: 1,
    pageSize: 10,
  };

  getFormTemplates(params: {
    page: number;
    pageSize: number;
    name?: string;
    orderBy?: string;
    desc?: boolean;
    usage?: FormTemplateUsage;
  }): Observable<Page<FormTemplateApi>> {
    const data = MOCK_DATA.filter(t => {
      if (!params.usage) return true;
      if (t.type !== FormTemplateTypes.ConsentForm) {
        return params.usage === FormTemplateUsage.Appointment;
      }
      return t.usage === params.usage;
    });

    const start = (params.page - 1) * params.pageSize;
    const items = data.slice(start, start + params.pageSize);

    return of({
      items,
      totalItems: data.length,
      pageNumber: params.page,
      pageSize: params.pageSize,
      totalPages: Math.ceil(data.length / params.pageSize),
    }).pipe(delay(500));
  }

  getFormTemplate(id: string): Observable<FormTemplateApi> {
    return this.getFormTemplates(this.params).pipe(
      map(templates => templates.items.find(t => t.id === id)),
      filter((t): t is FormTemplateApi => !!t)
    );
  }

  getFormTemplateNameById(id: string): Observable<string> {
    return this.getFormTemplate(id).pipe(map(t => t.name));
  }
}
